import PropTypes from 'prop-types';
import React from 'react';
import ReportDefinitions from '../../../../common/config/ReportDefinitions';
import Report from '../../../common/components/Report';

const HandlerMailRegistrationDeviceDeliveryReport = props => (
  <Report
    id={props.id}
    tabs={[
      {
        value: ReportDefinitions.HANDLER_MAIL_REGISTRATION_DEVICE_DELIVERY_SUMMARY.id,
        label: 'Summary',
      },
      {
        value: ReportDefinitions.HANDLER_MAIL_REGISTRATION_DEVICE_DELIVERY_CARRIER_PERFORMANCE.id,
        label: 'Carrier Performance',
        loadFromTable: true,
        loadFromTableMessage: 'app.warning.load.from.summary.report',
      },
      {
        value: ReportDefinitions.HANDLER_MAIL_REGISTRATION_DEVICE_DELIVERY_DETAILS.id,
        label: 'Details',
        loadFromTable: true,
        loadFromTableMessage: 'app.warning.load.from.summary.report',
      },
    ]}
    {...props}
  />
);
export default HandlerMailRegistrationDeviceDeliveryReport;

HandlerMailRegistrationDeviceDeliveryReport.propTypes = {
  id: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  generatedOnDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  reportId: PropTypes.string,
};
